export enum TopLevelMenuItems {
  ADMIN = 'admin',
  FINANCING = 'financing',
}
